module.exports = __webpack_public_path__ + "static/img/hbyk.b7fd2fe8.png";